import React from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import * as IoIcons from 'react-icons/io';
import * as FiActivity from 'react-icons/fi';

export const SidebarData = [
  {
    title: 'Home',
    path: '/',
    icon: <AiIcons.AiFillHome />,
    cName: 'nav-text',
  },
  {
    title: 'About',
    path: '/about',
    icon: <IoIcons.IoIosPaper />,
    cName: 'nav-text',
  },
  {
    title: 'Activity',
    path: '/activity',
    icon: <FiActivity.FiActivity />,
    cName: 'nav-text',
  },
  {
    title: 'Market',
    path: '/market',
    icon: <FaIcons.FaCartPlus />,
    cName: 'nav-text',
  },
  // {
  //   title: 'Editorial',
  //   path: '/editorial',
  //   icon: <IoIcons.IoMdPeople />,
  //   cName: 'nav-text',
  // },
  {
    title: 'Discover',
    path: '/discover',
    icon: <FaIcons.FaEnvelopeOpenText />,
    cName: 'nav-text',
  },
  {
    title: 'Support',
    path: '/support',
    icon: <IoIcons.IoMdHelpCircle />,
    cName: 'nav-text',
  },
];
